// Copyright (c) Move Closer 2022.

import { RouteNames as LoyaltyRoutes } from '../../loyalty/routes'
import { RouteNames as ProfileRoutes } from '../../profile/routes'
import { RouteNames as ProductsRoutes } from '../../products/routes'
import { RouteNames as OrderRoutes } from '../../orders/routes'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export enum TabOption {
  Loyalty = 'loyalty',
  Products = 'product',
  Profile = 'profile',
  Orders = 'order',
  Wishlist = 'wishlist'
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export enum AvailableTabOptionsKey {
  AddressesBillings = 'addressesBillings',
  BenefitPrograms = 'benefitPrograms',
  Favourite = 'favourite',
  HistoryOfOrders = 'historyOfOrders',
  Me = 'me',
  MyData = 'myData',
  Newsletter = 'newsletter'
}

/**
 * Registries containing routes / labels for specific profile tabs keys
 *
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const tabsItemsRouteNamesRegistry: Record<string, string> = {
  [AvailableTabOptionsKey.AddressesBillings]: `profile.${ProfileRoutes.AddressesBilling}`,
  [AvailableTabOptionsKey.BenefitPrograms]: `loyalty.${LoyaltyRoutes.Benefits}`,
  [AvailableTabOptionsKey.Favourite]: `products.${ProductsRoutes.Favourite}`,
  [AvailableTabOptionsKey.HistoryOfOrders]: `orders.${OrderRoutes.History}`,
  [AvailableTabOptionsKey.Me]: `profile.${ProfileRoutes.Account}`,
  [AvailableTabOptionsKey.MyData]: `profile.${ProfileRoutes.Profile}`,
  [AvailableTabOptionsKey.Newsletter]: `profile.${ProfileRoutes.Newsletter}`
}

export const tabsItemsLabelRegistry: Record<TabOption, string> = {
  [TabOption.Loyalty]: 'loyaltyTabs',
  [TabOption.Profile]: 'profileTabs',
  [TabOption.Products]: 'productTabs',
  [TabOption.Orders]: 'orderTabs',
  [TabOption.Wishlist]: 'wishlistTabs'
}
